export class ListItem {
	constructor(item, name, meta, message, icon, attr) {
		this.element = null;
		this.item = item;
		this.id = this.item.Id;
		this.name = name;
		this.meta = meta;
		this.message = message;
		this.icon = icon;
		this.attr = attr || '';
		this.isBookable = (this.item.IsBookable === true || this.item.IsBookable === false) ? this.item.IsBookable : true;
		this.allowBooking = (this.item.AllowBooking === true || this.item.AllowBooking === false) ? this.item.AllowBooking : true;
	}

	createElement() {
		this.element = this.getElementString();
	}

	appendToElement(el) {
		this.createElement();
		el.insertAdjacentHTML("beforeend", this.element);
	}

	getElementString() {
		let template = `
			<li class="c-list-item js-listItem" data-id="${this.id}" data-value="${this.name}" data-attr='${this.attr}' tabindex="0">
				${this.item.Url !== undefined ? `<a href='${this.item.Url}'>` : ''}
					${this.icon ? `<i class="im ${this.icon}"></i>` : ''}
					<span class="js-autocomplete__item">${this.name}</span>
					${this.meta ? `<span  class="c-filter__meta">${this.meta}</span>` : ''}
					${this.message ? `
						<div class="c-filter__meta u-ml">
							${this.message}
						</div>
					` : ''}
				${this.item.Url !== undefined ? `</a>` : ''}
			<li>
		`;

		if (!this.isBookable || !this.allowBooking) {
			template = `
			<li class="c-list-item ${!this.isBookable || !this.allowBooking ? 'unselectable' : 'js-listItem'}" tabindex="0">
					${this.icon ? `<i class="im ${this.icon}"></i>` : ''}
					<span>${this.name}</span>
					${this.meta ? `<span  class="c-filter__meta">${this.meta}</span>` : ''}
					${this.message ? `
						<div class="c-filter__meta u-ml">
							${this.message}
						</div>
					` : ''}
			<li>
		`;
		}
		return template;
	}
}